import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ps-operations-reports',
    template: '<app-reports-view category="PsOperations"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PsOperationsReportsComponent {

    constructor() { }

}
